import { Toast } from '@roo/roo'
import { parse } from '@utiljs/param'

export default {
	/**
	 * @description: 解析url中参数 k=v&k1=v1 为map对象格式
	 * @param {string} url 解析的URL参数
	 * @return:
	 */
	urlParse: (url?: string) => {
        url = url || window.location.search;
        if (!url) {
            const hash = window.location.hash;
            if (hash.indexOf('?') !== -1) {
                url = hash.substr(hash.indexOf('?'));
            }
        }
		let obj = parse(url)
		if (Object.keys(obj)[0] === '') {
			obj = {}
        }
		return obj
	},
	/**
	 * PC 里的弹框
	 * @param type success/fail/warn
	 * @param msg 错误信息
	 * @param duration toast 显示时间
	 * @param callback 回调
	 */
	toast: (type: 'success' | 'fail' | 'error' | 'warn' | 'warning', msg: string, duration?: number, callback?: () => {}) => {
		if (!duration) {
			duration = 2000
		}
		if (type === 'success') {
			duration = duration || 1000
		} else if (type === 'fail' || type === 'error') {
			duration = duration || 3000
			type = 'fail'
		} else if (type === 'warn' || type === 'warning') {
			duration = duration || 3000
			type = 'warning'
		}
		Toast.open({
			children: msg || '操作失败，系统异常',
			duration,
			status: type,
			position: 'topCenter',
			onClose: callback,
		})
	},
	// 简单深复制一个对象
	simpleCopy: (obj: any) => {
		if (obj) {
			// eslint-disable-next-line
			return JSON.parse(JSON.stringify(obj))
		} else {
			return obj
		}
	},
	// 简单对比两个数组是否一样
	simpleCompare: (sourceObj: Array<number>, targetObj: Array<number>) => {
		if (sourceObj && targetObj) {
			return JSON.stringify(sourceObj.sort()) === JSON.stringify(targetObj.sort())
		} else {
			return true
		}
    },
    /** 秒时间戳转换成时间 */
    timestampToMinutes(timestamp: number, type: 'minute' | 'second' = 'minute') {
        function add0(m: number) {
            return m < 10 ? `0${m}` : m;
        }
        const time = new Date(timestamp * 1000);
        const y = time.getFullYear();
        const m = time.getMonth() + 1;
        const d = time.getDate();
        const h = time.getHours();
        const mm = time.getMinutes();
        const s = time.getSeconds();
        return {
            date: `${y}-${add0(m)}-${add0(d)}`,
            time: `${add0(h)}:${add0(mm)}${type === 'second' ? ':' + s : ''}`,
        };
    },
    // 秒时间，转换为 时:分:秒格式，如3600转为 01:00:00
    secondsToHHMMSS(seconds: number) {
        const hh = Math.floor(seconds / 3600);
        const hhString = hh < 10 ? `0${hh}` : hh;
        const mm = Math.floor((seconds % 3600) / 60);
        const mmString = mm < 10 ? `0${mm}` : mm;
        const ss = (seconds % 3600) % 60;
        const ssString = ss < 10 ? `0${ss}` : ss;
        return {
            hh,
            mm,
            ss,
            hhmmss: `${hhString}:${mmString}:${ssString}`,
        };
    },
    // 时分秒格式转为秒时间，如：01:00:00转为 3600
    hhmmssToSeconds(hhmmss: string) {
        const arr: any = hhmmss.split(':');
        return arr[0] * 3600 + arr[1] * 60 + arr[2] * 1; // 最后的 *1 必须有，否则会当成字符串处理拼接
    },

    toChinesNum(num: number){
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
            let unit = ["", "十", "百", "千", "万"];
            num = parseInt(num.toString());
            let getWan = (temp: any) => {
                let strArr = temp.toString().split("").reverse();
                let newNum = "";
                for (var i = 0; i < strArr.length; i++) {

                    newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
                }
                if (newNum.slice(0,2) === '一十') {
                    newNum = newNum.replace('一十', '十')
                }
                return newNum;
            }
            let overWan = Math.floor(num / 10000);
            let noWan = (num % 10000).toString();
            if (noWan.toString().length < 4) noWan = "0" + noWan;
            return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
        }
}
